// extracted by mini-css-extract-plugin
module.exports = {"categoryTitle":"CategoryTitle_categoryTitle__3LE1p"};